import { render, staticRenderFns } from "./SingleAutobuyerInRow.vue?vue&type=template&id=629cb6b8&scoped=true&"
import script from "./SingleAutobuyerInRow.vue?vue&type=script&lang=js&"
export * from "./SingleAutobuyerInRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629cb6b8",
  null
  
)

export default component.exports